import React, { useEffect, useState } from "react"

import { Box, Button, Modal, Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import { useLoginContext } from "src/hooks/useLoginContext"
import { NEWS_INTERVIEW_TYPES_STRING, NEWS_MODAL_TYPE } from "src/modules/const"
import CheckBoxGroupField from "src/components/atom/CheckBoxGroupField"

type Prop = {
  id?: number
  type?: number
  category: string
  area: number
  isPublic?: boolean
  open: boolean
  handleOpen: any
  handlePublish?: any
  handlePrivate?: any
  handleDelete?: any
  handleSave?: any
  handlePublicState?: any
}

export const PublishModal = ({
  id,
  type,
  category,
  area,
  isPublic,
  open,
  handleOpen,
  handlePublish,
  handlePrivate,
  handleDelete,
  handleSave,
  handlePublicState,
}: Prop) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.news" })

  // const { loggedin, areas } = useLoginContext()
  const { areas } = useLoginContext()

  const [modalCategory, setModalCategory] = useState<string>(category)
  const [modalAreaID, setModalAreaID] = useState<number>(area)

  useEffect(() => {
    setModalCategory(category)
    setModalAreaID(area)
  }, [category, area])

  if (!id || !type || !category) {
    return <></>
  }

  const handle = (type: number) => {
    if (type == NEWS_MODAL_TYPE.PUBLISH) {
      handlePublish(modalCategory, modalAreaID)
    } else if (type == NEWS_MODAL_TYPE.PRIVATE) {
      handlePublicState(!isPublic)
      handlePrivate()
    } else if (type == NEWS_MODAL_TYPE.DELETE) {
      handleDelete()
    } else if (type == NEWS_MODAL_TYPE.SAVE) {
      handleSave(modalCategory, modalAreaID)
    }
    handleOpen(false)
  }

  return (
    <Modal
      open={open}
      onClose={() => handleOpen(false)}
      sx={{ height: "auto" }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      containerProps={{ sx: { width: "340px" } }}
    >
      <Box
        width="sm"
        display="flex"
        flexDirection="column"
        sx={{ borderRadius: "10px", bgcolor: "white", borderColor: "white", p: "0px" }}
      >
        <Box sx={{ p: "0px 10px" }}>
          {type === NEWS_MODAL_TYPE.PUBLISH && (
            <>
              <CheckBoxGroupField
                radio
                name={t("area")}
                nameSize={14}
                datas={areas}
                labelSize={14}
                lineSpace={0.5}
                selected={modalAreaID}
                handleSelected={setModalAreaID}
                sx={{ ml: "0px", mt: "10px", mb: "20px" }}
                labelStyle={{
                  fontSize: "16px",
                  fontFamily: "Noto Sans JP !important;",
                  fontWeight: "700",
                }}
                required
              />
              <CheckBoxGroupField
                radio
                name={t("please_select_category")}
                nameSize={14}
                datas={[
                  { label: t("news"), value: NEWS_INTERVIEW_TYPES_STRING.NEWS },
                  { label: t("interview"), value: NEWS_INTERVIEW_TYPES_STRING.INTERVIEW },
                ]}
                labelSize={14}
                lineSpace={0.5}
                selected={modalCategory}
                handleSelected={setModalCategory}
                sx={{ ml: "0px", mt: "10px", mb: "20px" }}
                labelStyle={{
                  fontSize: "16px",
                  fontFamily: "Noto Sans JP !important;",
                  fontWeight: "700",
                }}
                required
              />
              <Box display="block" textAlign="center">
                <Button
                  variant="contained"
                  className="notosans"
                  sx={{
                    my: "5px",
                    mx: "0.5rem",
                    width: 240,
                    height: 48,
                    fontSize: 16,
                    borderRadius: 0,
                    ":hover": {
                      bgcolor: "#2DA389",
                    },
                  }}
                  onClick={() => handle(NEWS_MODAL_TYPE.PUBLISH)}
                >
                  {t("publish")}
                </Button>
                <Button
                  variant="outlined"
                  className="notosans"
                  sx={{
                    my: "5px",
                    mx: "0.5rem",
                    width: 240,
                    height: 48,
                    fontSize: 16,
                    borderRadius: 0,
                    borderColor: "#1F6757",
                    color: "#1F6757",
                  }}
                  onClick={() => handleOpen(false)}
                >
                  {t("back")}
                </Button>
              </Box>
            </>
          )}
          {type === NEWS_MODAL_TYPE.DELETE && (
            <>
              <Typography.CardHead
                sx={{ fontSize: "16px", fontFamily: "Noto Sans JP !important;", fontWeight: "700" }}
              >
                {t("confirm_delete")}
              </Typography.CardHead>
              <Typography.CardHead
                sx={{
                  color: "#FC3317",
                  fontSize: "14px",
                  fontFamily: "Noto Sans JP !important;",
                  fontWeight: "700",
                  mt: "40px",
                }}
              >
                {t("delete_warning")}
              </Typography.CardHead>
              <Box display="block" textAlign="center">
                <Button
                  variant="outlined"
                  className="notosans"
                  sx={{
                    my: "5px",
                    mx: "0.5rem",
                    width: 240,
                    height: 48,
                    fontSize: 16,
                    borderRadius: 0,
                    borderColor: "#FC3317",
                    color: "#FC3317",
                  }}
                  onClick={() => handle(NEWS_MODAL_TYPE.DELETE)}
                >
                  {t("delete")}
                </Button>
                <Button
                  variant="outlined"
                  className="notosans"
                  sx={{
                    my: "5px",
                    mx: "0.5rem",
                    width: 240,
                    height: 48,
                    fontSize: 16,
                    borderRadius: 0,
                    borderColor: "#1F6757",
                    color: "#1F6757",
                  }}
                  onClick={() => handleOpen(false)}
                >
                  {t("back")}
                </Button>
              </Box>
            </>
          )}
          {type === NEWS_MODAL_TYPE.PRIVATE && (
            <>
              <Typography.CardHead
                sx={{ fontSize: "16px", fontFamily: "Noto Sans JP !important;", fontWeight: "700" }}
              >
                {isPublic ? t("private_warning") : t("public_warning")}
              </Typography.CardHead>
              <Box display="block" sx={{ mt: "40px" }} textAlign="center">
                <Button
                  variant="outlined"
                  className="notosans"
                  sx={{
                    my: "5px",
                    mx: "0.5rem",
                    width: 240,
                    height: 48,
                    fontSize: 16,
                    borderRadius: 0,
                    borderColor: isPublic ? "#FFB800" : "#1F6757",
                    color: isPublic ? "#FFB800" : "1F6757",
                  }}
                  onClick={() => handle(NEWS_MODAL_TYPE.PRIVATE)}
                >
                  {isPublic ? t("keep_private") : t("keep_public")}
                </Button>
                <Button
                  variant="outlined"
                  className="notosans"
                  sx={{
                    my: "5px",
                    mx: "0.5rem",
                    width: 240,
                    height: 48,
                    fontSize: 16,
                    borderRadius: 0,
                    borderColor: "#1F6757",
                    color: "#1F6757",
                  }}
                  onClick={() => handleOpen(false)}
                >
                  {t("back")}
                </Button>
              </Box>
            </>
          )}
          {type === NEWS_MODAL_TYPE.SAVE && (
            <>
              <CheckBoxGroupField
                radio
                name={t("area")}
                nameSize={14}
                datas={areas}
                labelSize={14}
                lineSpace={0.5}
                selected={modalAreaID}
                handleSelected={setModalAreaID}
                sx={{ ml: "0px", mt: "10px", mb: "20px" }}
                labelStyle={{
                  fontSize: "16px",
                  fontFamily: "Noto Sans JP !important;",
                  fontWeight: "700",
                }}
                required
              />
              <CheckBoxGroupField
                radio
                name={t("please_select_category")}
                nameSize={14}
                datas={[
                  { label: t("news"), value: NEWS_INTERVIEW_TYPES_STRING.NEWS },
                  { label: t("interview"), value: NEWS_INTERVIEW_TYPES_STRING.INTERVIEW },
                ]}
                labelSize={14}
                lineSpace={0.5}
                selected={modalCategory}
                handleSelected={setModalCategory}
                sx={{ ml: "0px", mt: "10px", mb: "20px" }}
                labelStyle={{
                  fontSize: "16px",
                  fontFamily: "Noto Sans JP !important;",
                  fontWeight: "700",
                }}
                required
              />
              <Box display="block" textAlign="center">
                <Button
                  variant="contained"
                  className="notosans"
                  sx={{
                    my: "5px",
                    mx: "0.5rem",
                    width: 240,
                    height: 48,
                    fontSize: 16,
                    borderRadius: 0,
                    ":hover": {
                      bgcolor: "#2DA389",
                    },
                  }}
                  onClick={() => handle(NEWS_MODAL_TYPE.SAVE)}
                >
                  {t("save")}
                </Button>
                <Button
                  variant="outlined"
                  className="notosans"
                  sx={{
                    my: "5px",
                    mx: "0.5rem",
                    width: 240,
                    height: 48,
                    fontSize: 16,
                    borderRadius: 0,
                    borderColor: "#1F6757",
                    color: "#1F6757",
                  }}
                  onClick={() => handleOpen(false)}
                >
                  {t("back")}
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Modal>
  )
}

// onClick={() => {
//   navigate("/signup/type")
// }}
